import { render, staticRenderFns } from "./SysTeacherEmoji.vue?vue&type=template&id=4edac603&scoped=true"
import script from "./SysTeacherEmoji.vue?vue&type=script&lang=js"
export * from "./SysTeacherEmoji.vue?vue&type=script&lang=js"
import style0 from "./SysTeacherEmoji.vue?vue&type=style&index=0&id=4edac603&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edac603",
  null
  
)

export default component.exports